module.exports = __webpack_public_path__ + "4d75982330564d155414d842dc5fc50d.ttf";